import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, Optional, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { BaseDialog } from '../base.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';


export interface ConfirmTransfertDialogData {
    textParams: any;
    data: ConfirmTransfertDialogData;
    success: boolean;

}

@Component({
    templateUrl: './confirm-transfer.dialog.html',
    styleUrls: ['./confirm-transfer.dialog.scss'],
})
export class ConfirmTransferDialog extends BaseDialog implements AfterViewInit, OnDestroy {
    public close: boolean;

    constructor(
        el: ElementRef,
        parentEvents: ParentEvents,
        renderer: Renderer2,
        private dialogRef: MatDialogRef<ConfirmTransferDialog>,
        @Optional()
        @Inject(MAT_DIALOG_DATA)
        public data: ConfirmTransfertDialogData

    ) {
        super(parentEvents, el, renderer);
    }

    onClose() {
        this.dialogRef.close(false);
    }

    onSubmit() {
        this.dialogRef.close(true);
    }
}
